module.exports = __webpack_public_path__ + "img/selected7-min.7d72d8a1.png";